import React, { useEffect } from "react";
import { useTable, useRowSelect } from "react-table";
import { Form, Table } from "react-bootstrap";
const IndeterminateFormCheck = React.forwardRef(
    ({ indeterminate, disabled, ...rest }, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            if (resolvedRef.current) {
                resolvedRef.current.indeterminate = indeterminate;
            }
        }, [resolvedRef, indeterminate, disabled]);

        console.log("Indeterminate IsDisabled:", disabled);

        return (
            <Form.Check
                type="checkbox"
                ref={resolvedRef}
                {...rest}
                disabled={disabled}
            />
        );
    }
);
const StudentList = ({
    data,
    columns,
    setSelectedUser,
    invoice,
    selectAllStudent,
    reason,
}) => {
    const hasPendingOrApprovedCN = (row) => {
        if (invoice?.credit_notes?.length > 0) {
            const isDisabled = invoice.credit_notes.some((item) => {
                if (
                    (item.type.toLowerCase() === "cancel-course" ||
                        item.type.toLowerCase() === "cancel-invoice") &&
                    (item.status_key.toLowerCase() == "pending" ||
                        item.status_key.toLowerCase() === "approved")
                ) {
                    return true;
                }

                if (
                    (item.type.toLowerCase() === "withdraw-student" ||
                        item.type.toLowerCase === "cancellation") &&
                    (item.status_key.toLowerCase() === "pending" ||
                        item.status_key.toLowerCase() === "approved")
                ) {
                    return item.invoice_course_students?.invoice_course_student_ids?.includes(
                        row.original.id
                    );
                }

                return false;
            });

            return isDisabled;
        }

        return false;
    };

    const isClassAllocated = (row) => {
        const isAllocated =
            row.original?.enrolment?.status_key?.toUpperCase() ===
            "CLASS-ALLOCATED";

        return isAllocated && reason !== "no-action";
    };

    const tableColumns = React.useMemo(
        () => [
            {
                id: "selection",
                Header: ({ getToggleAllRowsSelectedProps }) => {
                    const { disabled: _, ...props } =
                        getToggleAllRowsSelectedProps();
                    return (
                        <IndeterminateFormCheck
                            {...props}
                            disabled={selectAllStudent}
                        />
                    );
                },
                Cell: ({ row }) => {
                    if (row.isDisabled) return null;
                    const { disabled: _, ...props } =
                        row.getToggleRowSelectedProps();
                    return (
                        <IndeterminateFormCheck
                            {...props}
                            disabled={selectAllStudent}
                        />
                    );
                },
            },
            ...columns,
        ],
        [selectAllStudent, columns]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        selectedFlatRows,
        toggleAllRowsSelected,
    } = useTable(
        {
            columns: tableColumns,
            data,
        },
        useRowSelect,
        (hooks) => {
            hooks.prepareRow.push((row, { instance }) => {
                row.isDisabled =
                    hasPendingOrApprovedCN(row) || isClassAllocated(row);
            });
        }
    );

    useEffect(() => {
        toggleAllRowsSelected(selectAllStudent);
        console.log("IsAllStudentSelected", selectAllStudent);
    }, [selectAllStudent, toggleAllRowsSelected]);

    useEffect(() => {
        const filteredFlatRows = selectedFlatRows.filter((element) => {
            if (!element.isDisabled) return element;
        });
        setSelectedUser(filteredFlatRows);
    }, [selectedFlatRows, setSelectedUser]);

    return (
        <>
            {data.length > 0 && (
                <Table responsive striped bordered {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps()}>
                                        {column.render("Header")}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                        return (
                                            <td {...cell.getCellProps()}>
                                                {cell.render("Cell")}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            )}
        </>
    );
};
export default StudentList;
